
window.addEventListener("load", () => {
  
    document.body.classList.add('promo-banner--show')
    
    function setCookie(cookieName,cookieValue,daysToExpire,path,domain)
    {
      var date = new Date();
      date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
      //document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString() + 'path=' + path + 'domain=' + domain;
      document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString() + '; path=' + path + '; domain=' + domain;
    }
    
    
    function getCookieValue(cookieName) {
      var cookieValue = document.cookie.match('(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)');
      return cookieValue ? cookieValue.pop() : '';
    }
    
    if(getCookieValue('announcementbar')){
      document.body.classList.remove('promo-banner--show');
      document.querySelector(".header .announcement-slider").outerHTML = "";
    }else{
      document.body.classList.add('promo-banner--show');
      let closebtns = document.querySelectorAll("[data-anna-hide]")
      closebtns.forEach(closebtn =>{
        closebtn.addEventListener('click', function(event) {
            document.body.classList.remove('promo-banner--show');
            document.querySelector('.announcement-slider').remove();
          });
        })
    }

    
    // Select all announcement-slider elements
    var announcementSliders = document.querySelectorAll('.announcement-slider .flickity-slider');

    // Create a MutationObserver for each announcement-slider
    announcementSliders.forEach(function(slider) {
      var observer = new MutationObserver(function(mutationsList) {
        // Loop through the mutations
        mutationsList.forEach(function(mutation) {
          // Check if the mutation is for the 'style' attribute
          if (mutation.attributeName === 'style') {
            // Custom logic here
          }
        });
      });

      // Configure and start observing the flickity-slider element
      observer.observe(slider, { attributes: true });
    });



});